import isEqual from 'lodash/isEqual';
import throttle from 'lodash/throttle';


export default {

    props: {
        path: {type: String, default: null},
        route: {type: String, default: null},
        params: {type: Object, default: () => ({})},
        href: {type: String, default: null},
        blank: {type: Boolean, default: false},
        action: {type: [String, Function], default: null},
        mutation: {type: String, default: null},
        payload: {required: false},
        context: {required: false},
        icon: {type: String, default: ''},
        label: {default: ''},
        confirm: {type: [Boolean, String, Object], default: false},
        modal: {type: String, default: null},
        anchor: {type: [String, HTMLElement], default: null},
        anchorOffset: {type: [String, Number], default: 0},
    },

    data() {
        return {
            anchorActive: false,
        };
    },

    computed: {
        isActive() {
            if (this.anchor !== null && this.anchorActive) {
                return true;
            }

            if (!this.$route) {
                return false;
            }

            if (
                this.route && this.route === this.$route.name && this.$ui &&
                isEqual(this.$ui.paramsToString(this.params), this.$ui.paramsToString(this.$route.params))
            ) {
                return true;
            }

            return this.path && this.path === this.$route.path;
        },

        computedHref() {
            if (this.route) {
                let route = this.$router.resolve({
                    name: this.route,
                    params: this.params,
                });
                if (route) {
                    return route.href;
                }
            }
            if (this.path) {
                let route = this.$router.resolve(this.path);
                if (route) {
                    return route.href;
                }
            }
            if (this.href) {
                return this.href;
            }
            return "";
        },
    },

    methods: {
        handleClick(ev) {
            return this.confirm !== false ? this.confirmClick(ev) : this.click(ev);
        },

        async click(ev) {
            if (this.route) {
                this.$router.push({
                    name: this.route,
                    params: this.params,
                });
            } else if (this.path) {
                this.$router.push(this.path);
            } else if (this.href) {
                if (this.blank) {
                    window.open(this.href, '_blank');
                } else {
                    window.location.href = this.href;
                }
            } else if (this.action instanceof Function) {
                return this.action.call(this.context || this, this.payload);
            } else if (this.action) {
                return this.$store.dispatch(this.action, this.payload);
            } else if (this.mutation) {
                return this.$store.commit(this.mutation, this.payload);
            } else if (this.modal) {
                if (!this.$modal) {
                    console.warn('btn can not open modal because modal plugin not loaded.');
                    return;
                }
                this.$modal.open(this.modal, {...this.payload}, this.$listeners);
            } else if (this.anchor !== null) {
                this.$ui.scrollToElement(this.anchor, this.anchorOffset);
            } else {
                this.$emit('click', ev);
            }
        },

        confirmClick(ev) {
            if (!this.$modal) {
                console.warn("v-link confirm click does not work because modal plugin is not loaded.");
                return;
            }
            let config = {};
            switch (typeof this.confirm) {
                case "string": config.text = this.confirm; break;
                case "object": config = this.confirm; break;
            }
            config.action = () => this.click(ev);
            config.payload = this.payload;
            this.$modal.confirm(config, this.$listeners);
        },
    },

    mounted() {
        if (this.anchor !== null) {
            let {anchor} = this;

            if (typeof anchor === "string") {
                anchor = this.$parent.$el.querySelector(anchor);
            }

            let checkAnchor = throttle(() => {
                if (anchor instanceof HTMLElement) {
                    let {top, height} = anchor.getBoundingClientRect();
                    let {scrollTop} = this.$ui;
                    top = top + scrollTop - this.anchorOffset - 10; // -10 to prevent mismatch on small difference
                    this.anchorActive = top <= scrollTop && (top + height) >= scrollTop;
                }
            }, 50);

            checkAnchor();
            this.$watch('$ui.scrollTop', checkAnchor);
        }
    },
};
